import type { WishItem } from "../../models/contracts";
import { WishCard } from "./WishCard";

export const PolaroidWishRenderer = ({ wishes, focusId }: { wishes: WishItem[]; focusId: string | null }) => (
  <div class="wish-layout wish-layout-polaroid">{wishes.map((wish, index) => <WishCard key={wish.id} wish={wish} index={index} focusId={focusId} />)}</div>
);
